module.exports = __webpack_public_path__ + "img/sliders-02.e61a9660.jpg";